import api from "./api";
export const getDriverActivity = (params) => {
  return api.post("/getDriverActivity", params);
};

export const getBookingdetailsApi = (params) => {
  return api.post("/getBookingdetails", params);
};

export const getFiles = (params) => {
  return api.post("/getfiles", params);
};
